// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__3biZA","input":"checkbox_input__1b4Sa","inner":"checkbox_inner__3J9qI","label":"checkbox_label__Ip3VC"};